<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <!-- <p>SBC</p> -->
      </div>

      <div class="userheader">
        <img src="@/assets/images/user1.png" alt="" class="avatar">
      
        <p class="identity">{{ walletAddress ? '' + walletAddress : '加载地址中...' }}</p>
      </div>

      <div class="main">
        <div class="card4" @click="invite">
          <div class="Options">
            <img src="@/assets/images/us1.png" alt="">邀请好友
          </div>
          <img src="@/assets/images/arrow.png" alt="">
        </div>

        <div class="card4" @click="myteam">
          <div class="Options">
            <img src="@/assets/images/us2.png" alt="">我的社区
          </div>
          <img src="@/assets/images/arrow.png" alt="">
        </div>
        <div class="card4" @click="item">
          <div class="Options">
            <img src="@/assets/images/f2-2.png" alt="">團隊礦機
          </div>
          <img src="@/assets/images/arrow.png" alt="">
        </div>
        <div class="card4" @click="income">
          <div class="Options">
            <img src="@/assets/images/us3.png" alt="">我的资产
          </div>
          <img src="@/assets/images/arrow.png" alt="">
        </div>
        <div class="card4" @click="markt">
          <div class="Options">
            <img src="@/assets/images/us3.png" alt="">商城
          </div>
          <img src="@/assets/images/arrow.png" alt="">
        </div>

        <!-- 仅保留长按触发的设置按钮，增加移动端触摸事件 -->
        <div 
  class="card4" 
  @click="clickSettingTip"
  @mousedown="holdStart"
  @mouseup="holdEnd"
  @mouseleave="holdEnd"
  @touchstart="holdStart"
  @touchend="holdEnd"
>
  <div class="Options" id="settingsOption">
    <img src="@/assets/images/us4.png" alt="">设置
  </div>
  <img src="@/assets/images/arrow.png" alt="">
</div>

      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'user',
  data() {
    return {
      walletAddress: '',
      isOwner: false,
      nickname: 'User',
      holdTimer: null,
      holdDelay: 3000
    };
  },
  methods: {
    set() {
      this.$router.push('/settings');
    },
    income() {
      this.$router.push('/income');
    },
    markt() {
      this.$router.push('/markt');
    },
    myteam() {
      this.$router.push('/myteam');
    },
    item() {
      this.$router.push('/item');
    },
    invite() {
      this.$router.push('/copy-invite');
    },
    // 长按开始计时
    holdStart() {
      this.holdTimer = setTimeout(() => {
        this.checkAndNavigateToSettings();
      }, this.holdDelay);
    },
    // 松开/移出取消计时
    holdEnd() {
      if (this.holdTimer) {
        clearTimeout(this.holdTimer);
        this.holdTimer = null;
      }
    },
    async connectWallet() {
      if (typeof window.ethereum !== 'undefined') {
        try {
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          this.walletAddress = accounts[0];

          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const signer = provider.getSigner();
          const contract = new ethers.Contract(contractAddress, contractABI, signer);

          const owner = await contract.owner();
          this.isOwner = this.walletAddress.toLowerCase() === owner.toLowerCase();
        } catch (error) {
          console.error('连接钱包失败', error);
        }
      } else {
        console.error('请安装 MetaMask!');
      }
    },
    checkAndNavigateToSettings() {
      if (this.isOwner) {
        this.set();
      } else {
        alert('只有合约部署者可以访问此设置。');
      }
    },
    clickSettingTip() {
  alert('只有合约部署者可以访问此设置。');
},

    showInput() {
      document.getElementById('nicknameInput').style.display = 'inline';
      document.getElementById('nicknameDisplay').style.display = 'none';
      this.$nextTick(() => {
        document.getElementById('nicknameInput').focus();
        document.getElementById('nicknameInput').setSelectionRange(this.nickname.length, this.nickname.length);
      });
    },
    saveNickname() {
      document.getElementById('nicknameInput').style.display = 'none';
      document.getElementById('nicknameDisplay').style.display = 'inline';
    },
  },
  mounted() {
    this.connectWallet();
  },
};
</script>

<style scoped>
 /* 调整用户头像大小 */
.avatar {
  width: 126px;
  height: 126px;
  object-fit: cover;
  border-radius: 50%;
}

@import "@/assets/css/user.css";
@import "@/assets/css/style.css";
</style>
